function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.2969 5.53846C11.4063 5.53846 12.7969 4.8061 13.625 3.82962C14.375 2.94469 14.9219 1.70884 14.9219 0.472982C14.9219 0.30515 14.9063 0.137317 14.875 0C13.6406 0.0457724 12.1563 0.808646 11.2656 1.8309C10.5625 2.60903 9.92188 3.82963 9.92188 5.08074C9.92188 5.26383 9.95312 5.44692 9.96875 5.50795C10.0469 5.5232 10.1719 5.53846 10.2969 5.53846ZM6.39062 24C7.90625 24 8.57813 23.0083 10.4688 23.0083C12.3906 23.0083 12.8125 23.9695 14.5 23.9695C16.1562 23.9695 17.2656 22.4743 18.3125 21.0095C19.4844 19.3312 19.9688 17.6834 20 17.6071C19.8906 17.5766 16.7188 16.3102 16.7188 12.7552C16.7188 9.67324 19.2188 8.28481 19.3594 8.178C17.7031 5.85887 15.1875 5.79784 14.5 5.79784C12.6406 5.79784 11.125 6.89638 10.1719 6.89638C9.14062 6.89638 7.78125 5.85887 6.17188 5.85887C3.10937 5.85887 0 8.33058 0 12.9994C0 15.8983 1.15625 18.965 2.57812 20.9485C3.79687 22.6268 4.85937 24 6.39062 24Z",
  fill: "black"
});

function SvgAppleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = React.forwardRef(SvgAppleIcon);
export default __webpack_public_path__ + "static/media/apple-icon.f906e595.svg";
export { ForwardRef as ReactComponent };